import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiamond = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M18.25 7.75H1.75M15.25 3 10 7.75 4.75 3M17.9 6.848l-2.184-3.321c-.17-.283-.255-.425-.372-.528a.999.999 0 0 0-.356-.202c-.148-.047-.314-.047-.644-.047H5.656c-.33 0-.496 0-.644.047A1 1 0 0 0 4.656 3c-.117.103-.202.245-.372.528L2.1 6.848c-.196.327-.296.49-.33.663a1 1 0 0 0 .02.46c.048.17.158.324.38.633L8.7 16.16c.439.611.658.912.93 1.02a1 1 0 0 0 .74 0c.272-.108.491-.409.93-1.02l6.53-7.556c.222-.309.332-.463.38-.633a1 1 0 0 0 .02-.46c-.034-.173-.134-.336-.33-.663Z"
	})]
});
const ForwardRef = forwardRef(SvgDiamond);
export { ForwardRef as ReactComponent };
